import { format } from 'date-fns'

export const generateExportFileName = (screenName: string) => {
  const dateAndTime = format(new Date(), 'yyyyMMdd_HHmmss')
  return `${screenName}_Export_${dateAndTime}`
}
